import type { ComicEpisodeGenerateJob } from '../api/comicEpisodeJobs'
import { createAsyncTaskHub } from './asyncTaskHub'
import { SSE_EVENT_COMIC_EPISODE_JOB_UPDATED } from './sseEventNames'

export const comicEpisodeJobHub = createAsyncTaskHub<ComicEpisodeGenerateJob>({
  path: '/v1/comic-episode-generate-jobs/events',
  eventName: SSE_EVENT_COMIC_EPISODE_JOB_UPDATED,
  getId: (job) => job.publicId,
})
